<template>
    <div v-if="isLeserserviceOrHigher" class="customer-session-delete-btn">
        <v-tooltip left>
            <template #activator="{ on }">
                <v-btn small v-on="on" v-bind="$attrs" color="error" @click="show" :disabled="loading || deleting" :loading="deleting">
                    <v-icon small v-bind="$attrs">mdi-close-circle</v-icon>
                </v-btn>
            </template>
            <span>Session beenden</span>
        </v-tooltip>
        <v-dialog :value="showDialog && sessionId == selectedSessionId" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline" primary-title>Session beenden</v-card-title>
                <v-card-text>
                    <p class="body-1 mb-2">
                        Soll die Sitzung {{ text }} wirklich beendet werden?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" outlined @click="abbort" :disabled="loading || deleting">Abbrechen</v-btn>
                    <v-btn color="error" outlined :loading="deleting" :disabled="loading || deleting" @click="deleteSessionHandler">
                        Session beenden
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
} from 'vuex';

export default {
    name: 'SessionDeleteBtn',
    props: ['sessionId'],
    computed: {
        ...mapState('customerSessions', [
            'loading',
            'deleting',
            'showDialog',
            'selectedSessionId',
        ]),
        ...mapGetters('customerSessions', [
            'selectedSession',
        ]),
        ...mapGetters(['isLeserserviceOrHigher']),
        text() {
            if (this.selectedSession && this.selectedSession.session_id) {
                const deviceInfo = this.selectedSession.device_name_id ? ` (${this.selectedSession.device_name_id}) ` : ' ';
                return `"${this.selectedSession.session_id}"${deviceInfo}vom ${this.selectedSession.timestamp}`;
            }
            return '';
        },
    },
    methods: {
        ...mapMutations('customerSessions', [
            'hideDialog',
            'openDialog',
        ]),
        ...mapMutations('snackbar', ['success', 'error', 'info']),
        ...mapActions('customerSessions', [
            'deleteSession',
        ]),
        show() {
            this.openDialog(this.sessionId);
        },
        abbort() {
            this.hideDialog();
            this.info('Das Beenden wurde abgebrochen.');
        },
        deleteSessionHandler() {
            this.deleteSession()
                .then(() => {
                    this.success('Das Beenden war erfolgreich.');
                })
                .catch(() => {
                    this.error('Das Beenden ist fehlgeschlagen.');
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
